import { Box, SelectChangeEvent } from "@mui/material";
import { KeydriveTextfield } from "../../../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import usePrivilegeName from "../../../../../functions/hooks/usePrivilegeName";


interface IEditFolderGroupBoxItem {
    groupName: string;
    permissionType: number;
}

function EditFolderGroupBoxItem({
    groupName,
    permissionType,
}: IEditFolderGroupBoxItem) {

    const { privilegeName } = usePrivilegeName(permissionType);
    
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            mb="5px"
            gap={3}
        >
            <KeydriveTextfield 
                value={groupName}
                onChange={() => {}}
                label="Grupo"
                disabled
            />
            <KeydriveTextfield 
                value={privilegeName}
                onChange={() => {}}
                label="Privilégio"
                disabled
            />
        </Box>
    );
}

export default EditFolderGroupBoxItem;